import model from '../mixins/model';

export default {
    mixins: [model],
    model() {
        return {
            offers: []
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            this.dispatch((resolve, reject) => {

                this.$http.request({ url: 'offer.json', name: "cms" })
                    .then((response) => {
                        this.model.offers = response.data.posts;
                    })
                    .catch(reject);

            });


        },
    }
}